import React from 'react';

const SociaalDomein = () => (
	<svg viewBox="0 0 100 100" className="af-icon" xmlns="http://www.w3.org/2000/svg">
		<path d="M66.37 21.09a6.165 6.165 0 0 1 8.429-2.261 6.166 6.166 0 0 1 2.26 8.43 6.181 6.181 0 0 1-7.034 2.85L45.23 73.059c9.53 5.002 20.22 5.322 28.085 1.27l-2.906-5.03 10.91 1.88-3.82 10.39-2.681-4.64c-9.059 4.733-21.323 4.227-31.979-1.755l-.43-.246C31.645 68.71 24.9 58.192 24.469 47.838H19l7.09-8.51 7.08 8.51h-5.698c.418 8.847 6.048 17.957 15.16 23.719l24.793-42.948a6.19 6.19 0 0 1-1.055-7.519Zm6.929.337a3.166 3.166 0 0 0-4.33 1.16l-.086.162a3.184 3.184 0 0 0 1.248 4.171 3.175 3.175 0 0 0 4.33-1.162 3.167 3.167 0 0 0-1.162-4.331Z" fill="#FFF" fillRule="nonzero"/>
	</svg>
);

export default SociaalDomein;
